var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGist = function SvgGist(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M4.03437 2.20605H2.16671C1.98261 2.20605 1.83337 2.35529 1.83337 2.53939V11.8201C1.83337 12.0041 1.98261 12.1534 2.16671 12.1534H4.03437C4.21847 12.1534 4.36771 12.0041 4.36771 11.8201V2.53939C4.36771 2.35529 4.21847 2.20605 4.03437 2.20605Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M7.72236 2.20605H5.8547C5.6706 2.20605 5.52136 2.35529 5.52136 2.53939V11.8201C5.52136 12.0041 5.6706 12.1534 5.8547 12.1534H7.72236C7.90646 12.1534 8.0557 12.0041 8.0557 11.8201V2.53939C8.0557 2.35529 7.90646 2.20605 7.72236 2.20605Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M11.018 2.0577L9.23104 2.60082C9.0549 2.65436 8.95551 2.84054 9.00904 3.01668L11.7079 11.8963C11.7614 12.0724 11.9476 12.1718 12.1237 12.1183L13.9107 11.5751C14.0868 11.5216 14.1862 11.3354 14.1327 11.1593L11.4339 2.27969C11.3803 2.10355 11.1941 2.00416 11.018 2.0577Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M13.8334 13.0146H2.16671C1.98261 13.0146 1.83337 13.1639 1.83337 13.348V13.624C1.83337 13.8081 1.98261 13.9573 2.16671 13.9573H13.8334C14.0175 13.9573 14.1667 13.8081 14.1667 13.624V13.348C14.1667 13.1639 14.0175 13.0146 13.8334 13.0146Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgGist;